import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import HomeLight from './pages/HomeLight';
import Kitchens from './pages/Kitchens';
import Bathrooms from './pages/Bathrooms';
import Closets from './pages/Closets';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white text-primary font-sans selection:bg-accent selection:text-white">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home-light" element={<HomeLight />} />
            <Route path="/kitchens" element={<Kitchens />} />
            <Route path="/bathrooms" element={<Bathrooms />} />
            <Route path="/closets" element={<Closets />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
